var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./AddTrainingDefinitionWod.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-688dcaa9!../../node_modules/vue-loader/lib/selector?type=template&index=0!./AddTrainingDefinitionWod.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/modals/AddTrainingDefinitionWod.vue
// module id = 668
// module chunks = 0